import { Card, Col, Row } from "antd";
import CardButton from "../../components/CardButton/CardButton";
import { useNavigate } from "react-router-dom";

export default function Admin() {
    const navigate = useNavigate();
    return(
      <Card 
      style={{ width: '100%'}}
      title="ადმინისტრირება"
      >
        <Row justify="center" align="middle"  gutter={[16, 16]}>            
            <Col xs={24} lg={8}>
               <CardButton title="მომხმარებლების მართვა" icon={<i className="fa-solid fa-users-viewfinder" style={{ fontSize: 150, padding: 20, color: '#13c2c2'}}></i>} onClick={() => {navigate('/admin/users')}} />
            </Col>
            <Col xs={24} lg={8}>
               <CardButton title="დეპარტამენტების მართვა" icon={<i className="fa-solid fa-folder-tree" style={{ fontSize: 150, padding: 20, color: '#722ed1'}}></i>} onClick={() => {navigate('/admin/departments')}} />
            </Col>
            <Col xs={24} lg={8} >
               <CardButton title="დოკუმენტის საფეხურები" icon={<i className="fa-solid fa-file-signature" style={{ fontSize: 150, padding: 20, color: '#faad14'}}></i>} onClick={() => {navigate('/admin/document-hierarchy')}} />
            </Col>
            <Col xs={24} lg={8} >
               <CardButton title="დოკუმენტები" icon={<i className="fa-solid fa-book" style={{ fontSize: 150, padding: 20, color: '#c41d7f'}}></i>} onClick={() => {navigate('/admin/document')}} />
            </Col>
            <Col xs={24} lg={8} >
               <CardButton title="ფუტერი" icon={<i className="fa-solid fa-landmark-flag" style={{ fontSize: 150, padding: 20, color: '#73d13d'}}></i>} onClick={() => {navigate('/admin/footer')}} />
            </Col>
        </Row>
      </Card>
    )
}